import React from 'react';
import PropTypes from 'prop-types';
import { S3_SM_NC_DOC_FOLDER } from 'helpers/urlHelper';
import DocumentBaseModal from 'components/pages/skill-matrix/training-record/create-record/DocumentBaseModal';

const AddPhotoModal = ({
  isShow,
  handleClose,
  onSubmit,
  app,
  recordId,
  recordValue,
  title
}) => {
  return (
    <DocumentBaseModal
      isShow={isShow}
      handleClose={handleClose}
      onSubmit={onSubmit}
      app={app}
      recordValue={recordValue}
      documentFolderParam={S3_SM_NC_DOC_FOLDER + `/${recordId}`}
      title={title}
      recordId={recordId}
    />
  );
};
AddPhotoModal.propTypes = {
  isShow: PropTypes.bool,
  handleClose: PropTypes.func,
  onSubmit: PropTypes.func,
  app: PropTypes.string,
  stageId: PropTypes.number,
  recordId: PropTypes.number,
  recordValue: PropTypes.any,
  title: PropTypes.string
};

export default AddPhotoModal;
